/**
 * @generated SignedSource<<b2a44a9173a88026640dbd0769e67e4f>>
 * @relayHash 9256fa5b0ec219beb35ba6a309cb6c3c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6088baad78d018a6b6a01de8d3faac993a85cc7964a34f4f381724df595e8e64

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraIssueSearchFieldSetSelectedState = "ALL" | "NON_SELECTED" | "SELECTED" | "%future added value";
export type JiraIssueSearchFieldSetsFilter = {
  fieldSetSelectedState?: JiraIssueSearchFieldSetSelectedState | null | undefined;
  searchString?: string | null | undefined;
};
export type useColumnLoaderQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  filter?: JiraIssueSearchFieldSetsFilter | null | undefined;
  first?: number | null | undefined;
  issueKey: string;
};
export type useColumnLoaderQuery$data = {
  readonly jira: {
    readonly fieldSetViewQueryByProject: {
      readonly fieldSets?: {
        readonly edges: ReadonlyArray<{
          readonly cursor: string;
          readonly node: {
            readonly displayName: string | null | undefined;
            readonly fieldSetId: string | null | undefined;
            readonly fieldType: {
              readonly displayName: string | null | undefined;
            } | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
        };
        readonly totalCount: number | null | undefined;
      } | null | undefined;
      readonly id?: string;
    } | null | undefined;
  } | null | undefined;
};
export type useColumnLoaderQuery = {
  response: useColumnLoaderQuery$data;
  variables: useColumnLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v5 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "issueKey",
    "variableName": "issueKey"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    {
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filter"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "concreteType": "JiraIssueSearchFieldSetConnection",
      "kind": "LinkedField",
      "name": "fieldSets",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "totalCount"
        },
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "endCursor"
            }
          ]
        },
        {
          "concreteType": "JiraIssueSearchFieldSetEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "cursor"
            },
            {
              "concreteType": "JiraIssueSearchFieldSet",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "fieldSetId"
                },
                (v7/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "type"
                },
                {
                  "concreteType": "JiraFieldType",
                  "kind": "LinkedField",
                  "name": "fieldType",
                  "plural": false,
                  "selections": [
                    (v7/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraFieldSetView"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useColumnLoaderQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "LinkedField",
            "name": "fieldSetViewQueryByProject",
            "plural": false,
            "selections": [
              (v8/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "useColumnLoaderQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "LinkedField",
            "name": "fieldSetViewQueryByProject",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6088baad78d018a6b6a01de8d3faac993a85cc7964a34f4f381724df595e8e64",
    "metadata": {},
    "name": "useColumnLoaderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f6649e11b515173540fc95e306fa3718";

export default node;
